import React, { useState } from "react";
import inbox from "../assets/images/inbox.png";
import location from "../assets/images/location.png";
import logo from "../assets/images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import PrimaryButton from "./PrimaryButton";
import SeconadaryBtn from "./SeconadaryBtn";
import { DownOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import SAFlag from "../assets/icons/southafricaFlag.png";
import NAFlag from "../assets/icons/northamericaFlag.jpeg";
import DiabetesScreeningForm from "./DiabetesScreeningForm";

const Header = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isDiabetesScreeningModalOpen, setIsDiabetesScreeningModalOpen] =
    useState(false);

  React.useEffect(() => {
    const handleClickOutside = () => setDropdownOpen(false);
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const menuItems = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    { label: "Services", path: "/services" },
    // { label: "Membership Plan", path: "/membership" },
    // { label: "News", path: "/news&updates" },
    { label: "Families Caring", path: "/familiesCaring" },
    { label: "Contact Us", path: "/contactus" },
  ];

  return (
    <header className="header">
      {/* Top Section */}
      <div className="header-top">
        {/* Logo */}
        <Link to="/">
          <img src={logo} alt="VeriMed Logo" className="header-logo" />
        </Link>

        {/* Contact Info */}
        <div className="contact-info">
          <PrimaryButton
            label="Free Diabetes Screening & Kidney Protection Check"
            onClick={() => {
              setIsDiabetesScreeningModalOpen(true);
            }}
          />
          <span
            onClick={() =>
              window.open("https://maps.app.goo.gl/p4QzzbEx3FEEycxdA", "_blank")
            }
            className="contact-item"
          >
            <img src={location} alt="loc" className="contact-icon" />
            Buea Cameroon
          </span>

          <span
            onClick={(e) => {
              e.stopPropagation();
              window.location.href = "mailto:info@verimed.care";
            }}
            className="contact-item"
          >
            <img src={inbox} alt="mail" className="contact-icon" />
            info@verimed.care
          </span>

          <SeconadaryBtn
            label="Login"
            onClick={() => {
              window.location.href = "https://verimed-dashboard.vercel.app/";
            }}
          />
        </div>
      </div>

      {/* Bottom Navbar */}
      <div className="navbar-container">
        {/* Navbar Links */}
        <nav>
          <ul className="nav-list">
            {menuItems.map((item, index, array) => (
              <li
                key={index}
                onClick={() => {
                  setActiveIndex(index);
                  navigate(item.path);
                }}
                // style={{
                //   cursor: "pointer",
                //   paddingRight: index !== array.length - 1 ? "18px" : "0",
                //   marginRight: index !== array.length - 1 ? "10px" : "0",
                //   borderRight:
                //     index !== array.length - 1 ? "1px solid #fff" : "none",
                //   flexShrink: 0,
                //   whiteSpace: "nowrap",
                //   fontWeight: activeIndex === index ? "bold" : "normal",
                //   color: "#fff",
                //   position: "relative",
                //   transition: "all 0.3s ease",
                //   fontSize: 16,
                // }}
                className={`nav-item ${activeIndex === index ? "active" : ""} ${
                  index !== array.length - 1 ? "with-divider" : ""
                }`}
              >
                {item.label}
              </li>
            ))}
          </ul>
        </nav>

        {/* Call + Book Button */}
        <div className="action-section ">
          <div
            style={{
              display: "flex",
              flexDirection: "column", // stack items vertically
              justifyContent: "center",
              alignItems: "flex-start",
              gap: 5,
            }}
          >
            {/* North America row */}
            <div className="region-row">
              <img
                src={NAFlag}
                alt="North America Flag"
                className="flag-icon"
              />
              <span className="region-label">North America:</span>
              <span className="region-number">+1 551-502-0063</span>
            </div>

            {/* Africa & Europe row */}
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <img
                src={SAFlag}
                alt="Africa & Europe Flag"
                className="flag-icon"
              />
              <span className="region-label">Africa & Europe:</span>
              <span className="region-number">+237 6-50-41-99-86</span>
            </div>
          </div>

          {/* <PrimaryButton
            label="Enroll Patient"
            onClick={() => {
              navigate("/membership");
            }}
          /> */}

          <div
            style={{ position: "relative" }}
            onClick={(e) => {
              e.stopPropagation(); // prevent global click listener from closing
              setDropdownOpen(!dropdownOpen);
            }}
          >
            <PrimaryButton label="Enroll Patient" icon={<DownOutlined />} />

            {/* Dropdown menu */}
            {dropdownOpen && (
              <div className="header-dropdown">
                <div
                  className="header-dropwrapper"
                  onClick={() => {
                    setDropdownOpen(false);
                    navigate("/services");
                  }}
                >
                  Book a Service
                </div>
                <div
                  className="header-text"
                  onClick={() => {
                    setDropdownOpen(false);
                    navigate("/create_user");
                  }}
                >
                  Enroll a patient for future services
                </div>
              </div>
            )}
          </div>

          <Modal
            title="Enrollment Successful"
            width={400}
            open={isSuccessModalVisible}
            onCancel={() => setIsSuccessModalVisible(false)}
            footer={[
              <p>
                Sponsor Registration Successful
                <br /> Please check your email, a verification email is sent
              </p>,
            ]}
            centered
          ></Modal>

          <Modal
            title="Free Diabetes Screening & Kidney Protection Check"
            width={800}
            open={isDiabetesScreeningModalOpen}
            onCancel={() => setIsDiabetesScreeningModalOpen(false)}
            footer={null}
            centered
            bodyStyle={{ maxHeight: "80vh", overflowY: "auto" }}
          >
            <DiabetesScreeningForm
              onClose={() => setIsDiabetesScreeningModalOpen(false)}
            />
          </Modal>
        </div>
      </div>
    </header>
  );
};

export default Header;
